import {Gift} from 'lucide-react';
import {
  ExternalContainer,
  ImageWrapper,
  Image,
  CategoryBadge,
  ContentWrapper,
  TextWrapper,
  Title,
  Highlight,
  Price,
} from './styled';
import {truncateText} from './utils';

type Props = {
  href: string;
  title: string;
  highlight: string;
  imageUrl?: string;
  price?: string | null;
  categoryLabel?: string;
  className?: string;
};

const OfferCardExternal = ({
  href,
  title,
  highlight,
  imageUrl,
  price,
  categoryLabel,
  className,
}: Props) => {
  return (
    <ExternalContainer
      href={href}
      target="_blank"
      rel="nofollow"
      className={className}
    >
      <ImageWrapper>
        <Image src={imageUrl} alt={title} loading="lazy" />
        {categoryLabel && (
          <CategoryBadge>
            <Gift size={14} />
            {categoryLabel}
          </CategoryBadge>
        )}
      </ImageWrapper>
      <ContentWrapper>
        <TextWrapper>
          <Title>{title}</Title>
          <Highlight>{truncateText(highlight)}</Highlight>
        </TextWrapper>
        <Price>{price?.trim() || '\u00A0'}</Price>
      </ContentWrapper>
    </ExternalContainer>
  );
};

export {OfferCardExternal};
